import styled, { css } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Icon20 } from 'builder/components/Icon'
import { Icon56 } from 'builder/components/Icon/Icon'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const TickIcon = styled(Icon20.Check)`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: ${Colors.Green10};
  color: ${Colors.Green50};
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const WordIcon = styled(Icon56.Word)`
  margin-bottom: -16px;
`
export const WritingIcon = styled(Icon56.Writing)`
  margin-bottom: -16px;
`
export const TemplateIcon = styled(Icon56.Template)`
  margin-bottom: -16px;
`
export const CostumizationIcon = styled(Icon56.Costumization)`
  margin-bottom: -16px;
`

export const Items = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
`

export const Item = styled.div<{ borderTop?: boolean }>`
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${props =>
    props.borderTop &&
    css`
      padding-top: 24px;
      border-top: 1px ${Colors.Neutral15} solid;
    `}
`

export const ItemText = styled.div`
  display: flex;
  flex-direction: column;
`

export const ItemHeader = styled.div`
  ${Typography.Body}
  ${FontWeights.Regular}

  color: ${Colors.Neutral90};

  ${Media.Tablet`
    width: 212px;
  `}

  ${Media.Phone`
    width: 100%;
  `}
`

export const ItemDescription = styled.div`
  ${Typography.Caption};
  ${FontWeights.Regular};

  color: ${Colors.Neutral50};
`
